const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/config/triemli/eCheckin/sections/KontaktPerson.tsx';
import * as React from 'react';
import { forwardRef } from 'react';
import { useCIS4m, useCIS4mData } from '@cistec/common_web/modules/CIS4m/hooks';
import textMap from '../translations';
import { CIS4mTextField } from '@cistec/common_web/modules/CIS4m/components/CIS4mTextField';
import textMapCommon from '../../../common/translations';
import { AddressBlock, AddressFieldsConfig } from 'App/components/eCheckin/components/fields/AddressBlock';
import { ECheckinSectionProps } from 'App/components/eCheckin/types';
import { CIS4mPhoneNumberField } from '@cistec/common_web/modules/CIS4m/components/CIS4mPhoneNumberField';
import { validatePhoneNumber } from '@cistec/common_web/components/Forms/utils/validation';
import ECheckinSection from 'App/components/eCheckin/components/ECheckinSection';
import { CIS4mBlock } from '@cistec/common_web/modules/CIS4m/components/CIS4mBlock';
import CIS4mSingleCheckbox from '@cistec/common_web/modules/CIS4m/components/CIS4mSingleCheckbox';
import _ from 'lodash';
import { BeziehungField } from 'App/components/eCheckin/components/fields/metakat/BeziehungField';
import { createFieldPath } from 'App/components/eCheckin/utils';
import { useText } from '@cistec/common_web/utils/intlUtils';
import { Divider } from '@mui/material';
import { EMailField } from 'App/components/eCheckin/components/fields/EMailField';
import { CountryField } from 'App/components/eCheckin/components/fields/metakat/CountryField';

const addressFieldsConfig: AddressFieldsConfig = {
    additionalInfo: {
        included: false,
    },
    country: {
        included: false,
    },
};

export const KontaktPerson = forwardRef((props: ECheckinSectionProps, ref: any) => {
    const { path } = props;
    const title = useText(props.title);

    const PATH_NOT_SPECIFIED = createFieldPath(path, 'notSpecified');
    const PATH_SECOND_CONTACT = createFieldPath(path, 'secondContact');

    const formData = useCIS4mData();
    const keineAngaben = _.get(formData, PATH_NOT_SPECIFIED) === '1';
    const hasSecondContact = _.get(formData, PATH_SECOND_CONTACT) === '1';

    const eCheckinSectionRef = useCIS4m(ref);

    const getContactPersonFields = (prefix: string = '', condition: boolean = true) => {
        const PATH_RELATION = createFieldPath(path, `${prefix}relation`);
        const PATH_OTHER_RELATION = createFieldPath(path, `${prefix}otherRelation`);
        const PATH_FIRST_NAME = createFieldPath(path, `${prefix}firstname`);
        const PATH_LAST_NAME = createFieldPath(path, `${prefix}lastname`);
        const PATH_COUNTRY = createFieldPath(path, `${prefix}country`);
        const PATH_TEL = createFieldPath(path, `${prefix}tel`);
        const PATH_EMAIL = createFieldPath(path, `${prefix}email`);
        const PATH_ADDRESS = createFieldPath(path, `${prefix}address`);
        const isRelationElse = _.get(formData, PATH_RELATION) === 'Sonstige';

        return (
            <CIS4mBlock hidden={condition}>
                <BeziehungField label={textMap.beziehung} path={PATH_RELATION} required />
                <CIS4mTextField
                    label={textMap.beziehung}
                    path={PATH_OTHER_RELATION}
                    hidden={!isRelationElse}
                    required={isRelationElse}
                />
                <CIS4mTextField label={textMapCommon.lastname} path={PATH_LAST_NAME} required />
                <CIS4mTextField label={textMapCommon.firstname} path={PATH_FIRST_NAME} required />
                <AddressBlock basePath={PATH_ADDRESS} fieldsConfig={addressFieldsConfig} />

                <CountryField label={textMap.country} path={PATH_COUNTRY} required />
                <CIS4mPhoneNumberField
                    label={textMapCommon.tel}
                    path={PATH_TEL}
                    checkValidity={validatePhoneNumber}
                    countryCodePath={PATH_COUNTRY}
                    required
                />
                <EMailField label={textMapCommon.email} path={PATH_EMAIL} />
            </CIS4mBlock>
        );
    };

    return (
        <ECheckinSection ref={eCheckinSectionRef} path={props.path} title={title}>
            <h1>{title}</h1>
            <CIS4mSingleCheckbox label={textMap.keineKonaktperson} path={PATH_NOT_SPECIFIED} />
            {getContactPersonFields('', keineAngaben)}
            <Divider hidden={keineAngaben} />
            <CIS4mSingleCheckbox label={textMap.secondContact} path={PATH_SECOND_CONTACT} hidden={keineAngaben} />
            {getContactPersonFields('second', !hasSecondContact || keineAngaben)}
        </ECheckinSection>
    );
});

KontaktPerson.displayName = 'KontaktPerson';

export default KontaktPerson;
